module.exports = __webpack_public_path__ + "static/media/biohazard.ab3bc21d.svg";